import { useEffect, useState, useRef } from "react";
// import * as APIHelper from '../Helper/mockAPIFetch';
import * as APIHelper from '../Helper/apiFetch';
import * as nativeEvents from '../Helper/native';
import { useNavigate } from "react-router-dom";
import RenderShimmer from "../components";
import loaderLottie from '../loaderlottie.json';
import Lottie from "lottie-react";

export default function Loading() {
    const tokenCheckTimerRef = useRef(null);
    const navigate = useNavigate();
    const [user, setUser] = useState(null);

    // Function to check if all images are loaded
    const checkImagesLoaded = () => {
        const images = document.querySelectorAll('img');
        let loadedCount = 0;
        const totalImages = images.length;

        // If no images, navigate immediately
        if (totalImages === 0) {
            navigate('/home');
            return;
        }

        const imageLoaded = () => {
            loadedCount++;
            if (loadedCount === totalImages) {
                // All images loaded, navigate to home
                navigate('/home');
            }
        };

        images.forEach((img) => {
            if (img.complete) {
                imageLoaded();
            } else {
                img.addEventListener('load', imageLoaded);
                img.addEventListener('error', imageLoaded); // Handle errors
            }
        });
    };

    useEffect(() => {
        tokenCheckTimerRef.current = setInterval(async () => {
            const url = new URL(window.location.href);
            const tokenHeader = url?.searchParams.get('token');
            const refreshToken = url?.searchParams.get('refreshToken');

            tokenHeader && sessionStorage.setItem('AccessToken', tokenHeader);
            refreshToken && sessionStorage.setItem('RefreshToken', refreshToken);
            
            const jwt = tokenHeader || sessionStorage.getItem('AccessToken');

            if (jwt) {
                clearInterval(tokenCheckTimerRef.current);
                // Check images after token is found
                setTimeout(checkImagesLoaded, 100);
            }
        }, 2000);
      
        // APIHelper.postAnalytics("ipl_banner");
        window.onpopstate = e => {
            console.log(e);
            nativeEvents.goBack()
        }

        return () => {
            clearInterval(tokenCheckTimerRef.current);
        }
    }, [navigate]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#6F42AA' }}>
            <Lottie animationData={loaderLottie} loop={true} style={{ height: '230px', width: '230px' }} />
        </div>
    );
}